// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"338":"SecuritySettings","655":"TranslationEmailReportOverview","1440":"IntegrationSettings","3971":"ProFormaInvoices","4410":"TranslationReport"}[chunkId] + "." + {"338":"8813d55d","655":"af93c289","1440":"4acdf64b","3971":"224426ae","4410":"c58fdd92"}[chunkId] + ".css";
};